export default {
  "content": "<path d=\"M0 0h12.009v81H0zm59.446 0h12v81h-12zM204 27h9.559v54H204zM331 0h9.559v81H331zM228 27h14v54h-14zM354 0h12v81h-12zM26.821 0h19.214v81H26.821zM254 27h16.813v54H254zM379 0h16.813v81H379zM84.464 0h5v81h-5zm18 0h8v81h-8zM156 27h34v54h-34zM302 0h16v81h-16zm-18 0h6v81h-6zM121.89 27h21.21v54h-21.21z\" fill=\"#3F4450\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "396",
    "height": "81",
    "viewBox": "0 0 396 81"
  }
};